import { React } from "react";


function NotFound() {
	return (
		<div>
			<p
				data-aos={"fade-up"}
				data-aos-offset={300}
				data-aos-duration={900}
				data-aos-delay={600}
			>
				Not Found Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta
				blanditiis minus veritatis ratione nam. Sit, maxime quaerat voluptas
				assumenda nesciunt voluptatum eum repellat ipsa quam officiis corporis
				alias sunt nihil!
			</p>
		</div>
	);
}

export default NotFound;
